import * as React from "react";
import { ToastContext } from "./toast.context.js";
const useToast = () => {
  const { addToast } = React.useContext(ToastContext);
  return addToast;
};
export {
  useToast
};
//# sourceMappingURL=toast.hooks.js.map
